export default __webpack_public_path__ + "locales/lo-LA/Files.json?hash=3c9273c51c43b82bfeb62bf52b256f73";